export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const SET_AUTH_DIALOG = 'SET_AUTH_DIALOG';
